/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/10
 * Time: 9:37
 * Desc: 顾客分销管理-结算管理
 */

import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import moment from 'moment';
import type { ElForm } from 'element-ui/types/form';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import { appEnvConfig } from '@/configs/appConfigs';
import NoAuth from '@/views/components/noAuth/noAuth.vue';
import baseAPIService from '@/services/base/baseAPIService';
import { EmpServiceAPIActions } from '@/services/empService';
import { PolicyTypeText } from '@/views/components/newDistribution/newDistributionList';
import ExportFile from '@/views/components/exportFile';
import importBatchSet from '@/views/components/importBatchSet';
import { noop, showPlatform } from '@/util';
import NewSelectSite from '@/views/components/newSelectSIte';

export enum PAY_TYPE {
  ON_LINE_PAY = 1,
  BATCH_ON_LINE_PAY,
  OFF_LINE_PAY,
  BATCH_OFF_LINE_PAY,
}

@Component({
  components: {
    NoAuth,
    ExportFile,
  },
})
export default class RemitManage extends Vue {
  /* 数据 */

  $refs: {
    form: ElForm;
    export: ExportFile;
  };

  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  /**
   * 当前页面的索引 / 提现状态
   * @type {string}
   */
  public curPage = '1';

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * table的高度
   * @type {Array<RemitList>}
   */
  public remitList: Array<RemitList> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 结算类型
   */
  public accountType = '';
  /**
   * 排序名称
   * @type {string}
   */
  public order = '';

  /**
   * 排序方式
   * @type {string}
   */
  public orderBy = '';

  /**
   * 是否选中列表项
   * @type {boolean}
   */
  public isSelected = false;

  /**
   * 选中的列表
   * @type {Array<RemitList>}
   */
  public selectedList: Array<RemitList> = [];

  /**
   * 拒绝弹窗是否显示
   * @type {boolean}
   */
  public isRejectedReasonPopShow = false;

  /**
   * 拒绝理由类型
   * @type {string}
   */
  public rejectedReasonType = 'self';

  /**
   * 拒绝理由
   * @type {string}
   */
  public rejectedReason = '';

  /**
   * 当前提现记录Id
   * @type {number | string}
   */
  public curOutId: any = [];

  /**
   * 标签筛选条件
   * @type {string}
   */
  public queryParamTag = ''; // 0 普通顾客、1 公司员工、2 公司导购、3 签约网红、4 黄牛 9 全部

  public isShowBank=false

  /**
   * 页面名称
   * @type {ItemObject}
   */
  public pageNameObj: ItemObject = {
    p1: 'VSHOP-FUNCTION-DISTRIBUTE-CASH-VERIFY1', // 待业务审核
    p2: 'VSHOP-FUNCTION-DISTRIBUTE-CASH-VERIFY2', // 待总部审核
    p3: 'VSHOP-FUNCTION-DISTRIBUTE-CASH-PAY', // 待结算
    p4: 'VSHOP-FUNCTION-DISTRIBUTE-CASH-HASPAY', // 已结算
    p5: 'VSHOP-FUNCTION-DISTRIBUTE-CASH-HASFAILED', // 打款失败
    p6: 'VSHOP-FUNCTION-DISTRIBUTE-CASH-HASDENY', // 已拒绝
  };

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /**
   * socket连接准备
   * @type {boolean}
   */
  public isSocketReady = false;

  /**
   * 显示设置扣税金额弹窗
   * @type {boolean}
   */
  public isSetTax = false;

  /**
   * 文件上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /**
   * 文件名
   * @type {string}
   */
  public fileName = '';

  /**
   * 选择文件
   * @type {any}
   */
  public importFile: any = {};

  /**
   * 发送消息地址列表
   * @type {Array<string>}
   */
  public sendToIdList: Array<string> = [
    `${appEnvConfig.NODE_ENV}RemitManage${this.$store.state.empCode}`, // 待结算
    `${appEnvConfig.NODE_ENV}templateCount${this.$store.state.empCode}`, // 模板1
    `${appEnvConfig.NODE_ENV}templateImport${this.$store.state.empCode}`, // 模板2
    `${appEnvConfig.NODE_ENV}import${this.$store.state.empCode}`, // 导入
  ];

  /**
   * 点击导出按钮 0 待结算页面导出按钮 1 下载合计数据模板 2 下载含数据导入模板
   * @type {number}
   */
  public exportIndex = 0;

  /**
   * 失败数量
   * @type {number}
   */
  public failNum = 0;

  /**
   * 下载失败文件地址
   * @type {string}
   */
  public failFileURL = '';

  /**
   * 导入状态 1 导入中 2 导入成功 3 导入失败
   * @type {number}
   */
  public importState = 0;

  /**
   * 显示批量设置扣税金额按钮
   * @type {number}
   */
  public isImportButton = 0;

  /**
   * 确认标题
   * @type {string}
   */
  public confirmTitle = '';

  /**
   * 输入确认信息
   * @type {string}
   */
  public inputConfirm = '';

  /**
   * 是否确认打款弹窗
   * @type {boolean}
   */
  public isShowConfirm = false;

  /**
   * 打款成功消息
   * @type {string}
   */
  public successMessage = '';

  /**
   * 打款失败消息
   * @type {string}
   */
  public errorMessage = '';

  /**
   * 打款类型
   * @type {number}
   */
  public payType = 0;

  /**
   * 选中打款人信息
   */

  public selectedInfo: RemitList = null;

  // 是否使用优惠券

  public isCoupon = null;
  /**
   * 验证输入框输入内容
   */
  public rules = {
    inputConfirm: [{ validator: this.v_inputConfirm, trigger: 'blur' }],
  };

  public isDisabledConfirm = false;

  /**
   * 输入选择
   */
  public reviewerType = 0;

  public selectType = [
    { label: '默认', value: 0 },
    { label: '业务审核人', value: 1 },
    { label: '财务审核人', value: 2 },
  ];

  // 结算类型
  public outLineOption = [
    { label: '现金结算', value: null },
    { label: '现金券结算', value: 1 },
  ];

  // 申请时间选择

  public timeType = 1;

  // 搜索时间
  public date = [];

  public defaultStart: Date;

  public defaultEnd: Date;

  /**
   * 输入框placeholder
   * @type {string[]}
   */
  public placeholderList = ['姓名/手机号/网点编号/网点名称', '输入业务审核人姓名', '输入财务审核人姓名'];

  /**
   * 网点树列表
   * @type {ItemArray}
   */
  public siteTreeList = [];

  /**
   * 网点列表
   * @type {string[]}
   */
  public siteCodes = [];

  /**
   * 分销类型
   * @type {number | string}
   */
  public distributionType = '';

  /**
   * 分销类型列表
   * @type {ItemArray}
   */
  public distributionTypeList = PolicyTypeText;

  /**
   * 角色标签列表
   * @type {ItemArray}
   */
  public tagTypeList = [];

  /**
   * 角色标签类型
   * @type {string | number}
   */
  public tagType = '';

  /* 方法 */

  /**
   * 监听弹窗打开
   */
  @Watch('isSetTax')
  watchIsSetTax(newVal) {
    this.fileName = '';
    this.importFile = {};
    this.importState = 0;
    this.failFileURL = '';
  }

  /**
   * 监听打款弹窗
   */
  @Watch('isShowConfirm')
  watchExportBtnInfo(newVal) {
    this.isDisabledConfirm = false;
    if (!newVal) {
      this.selectedInfo = null;
      this.payType = 0;
      this.successMessage = '';
      this.errorMessage = '';
      this.inputConfirm = '';
      this.confirmTitle = '';
    }
  }

  /**
   * 验证是输入内容是否相同
   */
  public v_inputConfirm(rule, value, callback) {
    if (value !== this.confirmTitle) {
      callback(new Error('文本不匹配'));
    } else {
      callback();
    }
  }

  /**
   * 文件上传之前
   * @param {ItemObject} file
   * @return boolean
   */
  public onBeforeUpload(file: ItemObject): boolean {
    const fileType = file.name.slice(Math.max(0, file.name.lastIndexOf('.') + 1));
    const extension2 = fileType === 'xlsx';
    this.fileName = file.name;
    this.importFile = file;
    if (!extension2) {
      this.$message({
        message: '上传文件只能是 xls、xlsx、excel格式!',
        type: 'warning',
      });
    }
    const LtSize = file.size / 1024 <= 2048;
    if (!LtSize) {
      this.$message.error('上传文件大小不能超过 2M!');
    }
    return false;
  }

  /**
   * 文件上传成功时的处理
   * @param res
   * @param file
   */
  public uploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {}

  /**
   * 图片上传失败
   * @return null
   */

  public uploadImgError() {
    this.$message.error('文件上传失败');
  }

  /**
   * 根据关键字搜索
   * @return null
   */
  public onSearchRemitList(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getRemitList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getRemitList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getRemitList();
  }

  // 日期前的类型切换
  public onSelectDateType(value) {
    this.timeType = value;
    this.date = [];
  }

  // 日期切换
  public dateChange() {
    this.page = 1;
    this.getRemitList();
  }

  /**
   * 选中的活动
   * @param val
   * @return null
   */
  public onHandleSelectionChange(val): void {
    this.isSelected = val.length > 0;
    this.selectedList = val;
  }

  /**
   * 隐藏拒绝理由弹窗
   * @return null
   */
  public onRejectedReasonPopHide(): void {
    this.isRejectedReasonPopShow = false;
    this.rejectedReasonType = 'self';
    this.rejectedReason = '';
  }

  /**
   * 打开拒绝理由弹窗
   * @param {number|string} val
   * @return null
   */
  public onRejectedReasonPopShow(val?): void {
    const idList = [];
    if (!val) {
      this.selectedList.forEach((item) => {
        idList.push(item.outId);
      });
    }
    this.isRejectedReasonPopShow = true;
    this.curOutId = val ? [val] : idList;
  }

  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.keywords = '';
    this.page = 1;
    this.pageSize = 10;
    this.order = '';
    this.orderBy = '';
    this.curPage = key;
    this.date = [this.defaultStart, this.defaultEnd];
    this.timeType = 1;
    this.accountType = '';
    if (key != 3) {
      this.reviewerType = 0;
    }
    this.$refs.export.reset();
    this.queryParamTag = '';
    this.setCurPageName(key); // 设置当前页索引到缓存
    // 表格恢复到初始状态
    // @ts-expect-error
    this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
    // @ts-expect-error
    this.$refs.multipleTable.bodyWrapper.scrollLeft = 0;
    this.siteCodes = [];
    this.selectedList = [];
    this.isSelected = false;
    this.distributionType = '';
    this.tagType = '';
    this.getRemitList(); // 获取提现列表
  }

  /**
   * 列表排序
   * @param {ItemObject} column
   * @return null
   */
  public onSortChange(column: ItemObject): void {
    this.order = column.prop;
    this.orderBy = column.order === 'ascending' ? 'ASC' : 'DESC';
    this.getRemitList(); // 获取提现列表
  }

  /**
   * 获取左侧树列表
   * @return null
   */
  // getTreeList() {
  //   return IPSService.getAdminAuthTree().then((response) => {
  //     return response.treeList;
  //   });
  // }
  openSelectSiteDialog() {
    new NewSelectSite().open({
      service: 'authTree',
      selectCodes: this.siteCodes,
      readonly: false,
    }).then((val: string[]) => {
      this.siteCodes = val;
      this.getRemitList()
      this.getTagList();
    }, noop);
  }
  /**
   * 获取提现管理列表
   * @return null
   */
  public async getRemitList() {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    this.remitList = [];
    const postParams = {
      keywords: this.keywords,
      level: this.curPage !== '5' ? (this.curPage === '6' ? 4 : Number.parseInt(this.curPage) - 1) : 10, // 0待业务审核 1待总部审核 2待结算(待财务审核) 3已结算 10打款失败 5已拒绝
      order: this.order,
      orderBy: this.orderBy,
      page: this.page,
      pageSize: this.pageSize,
      accountType: this.accountType || 9,
      reviewerType: this.reviewerType,
      tag: this.queryParamTag ? Number.parseInt(this.queryParamTag) : '9',
      siteCodes: this.siteCodes,
      policyType: this.distributionType === '' ? 9 : this.distributionType,
      tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
      timeType: this.timeType || 1,
    };

    if (this.date && this.date.length) {
      postParams['startTime'] = moment(this.date[0]).format('YYYY-MM-DD');
      postParams['endTime'] = moment(this.date[1]).format('YYYY-MM-DD');
      if (this.date[1] - this.date[0] > 184 * 24 * 3600 * 1000) {
        this.$message.error('时间跨度不能超过6个月！');
        this.date = [this.defaultStart, this.defaultEnd];
        postParams['startTime'] = moment(this.date[0]).format('YYYY-MM-DD');
        postParams['endTime'] = moment(this.date[1]).format('YYYY-MM-DD');
        this.ipsGetList(postParams, loading);
      }
    }
    // if (!this.siteTreeList || !this.siteTreeList.length) {
    //   this.siteTreeList = await this.getTreeList();
    // }
    this.ipsGetList(postParams, loading);
  }

  ipsGetList(postParams, loading) {
    IPSService.guiderAllProfitOutList({ postParams }).then(
      (res) => {
        loading.close();
        this.isImportButton = res.isImportButton || 0;
        // 格式化数据
        res.list.forEach((item: any) => {
          item.addTime = Functions.emptyVaribleHandler(item.addTime);
          item.reviewContent1 = Functions.emptyVaribleHandler(item.reviewContent1);
          item.reviewTime1 = Functions.emptyVaribleHandler(item.reviewTime1);
          item.reviewContent2 = Functions.emptyVaribleHandler(item.reviewContent2);
          item.reviewTime2 = Functions.emptyVaribleHandler(item.reviewTime2);
          item.reviewContent3 = Functions.emptyVaribleHandler(item.reviewContent3);
          item.merchantNumber = Functions.emptyVaribleHandler(item.merchantNumber);
          item.reviewTime3 = Functions.emptyVaribleHandler(item.reviewTime3);
          item.lastOutTime = Functions.emptyVaribleHandler(item.lastOutTime);
          item.remitNumber = Functions.emptyVaribleHandler(item.remitNumber);
          item.historyOutTotal = item.historyOutTotal ? item.historyOutTotal.toFixed(2) : 0;
          item.balance = item.balance ? item.balance.toFixed(2) : 0;
          item.taxesBalance = item.taxesBalance ? item.taxesBalance.toFixed(2) : 0;
          item.serviceFee = item.serviceFee ? item.serviceFee.toFixed(2) : 0;
          item.realOutCash = item.realOutCash ? item.realOutCash.toFixed(2) : 0;
          item.remainBalance = item.remainBalance ? item.remainBalance.toFixed(2) : 0;
          item.tagName = Functions.emptyVaribleHandler(item.tagName);
        });
        this.totalCount = res.count;
        this.remitList = res.list;
      },
      () => {
        loading.close();
      },
    );
  }

  /**
   * 虚拟店长提现审核通过
   * @param {number} id
   * @return null
   */
  public onConfirmRemit(id: number): void {
    this.$confirm('是否通过？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then(() => {
      const postParams = {
        outId: `${id}`,
        level: this.curPage === '1' ? 1 : 2, // 1业务审核提交 2总部审核提交  3财务打款(暂无)
      };
      IPSService.guiderAllProfitOutPassed({ postParams }).then((res) => {
        if (res) {
          this.$message.success('审核通过');
          this.getRemitList();
        } else {
          this.$message.success('审核失败');
        }
      });
    });
  }

  /**
   * 批量通过
   * @return null
   */
  public onConfirmRemitMult(): void {
    const idList = [];
    if (this.selectedList.length > 0) {
      this.selectedList.forEach((item) => {
        idList.push(item.outId);
      });
      this.$confirm('是否批量通过？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        const postParams = {
          outId: idList.join('|'),
          level: this.curPage === '1' ? 1 : 2, // 1业务审核提交 2总部审核提交  3财务打款(暂无)
        };
        IPSService.guiderAllProfitOutPassed({ postParams }).then((res) => {
          if (res) {
            this.$message.success('批量审核通过');
            this.getRemitList();
          } else {
            this.$message.success('批量审核失败');
          }
        });
      });
    }
  }

  /**
   * 审核弹窗拒绝理由
   * @param {number|string} val
   * @return null
   */
  public onRejectedReasonTypeChange(val: any): void {
    this.rejectedReason = '';
    if (val !== 'self') {
      this.rejectedReason = '提现记录异常';
    }
  }

  /**
   * 提交拒绝提现信息
   * @return null
   */
  public onSubmitRemitRejectData(): void {
    const reviewContent = Functions.trim(this.rejectedReason);
    if (reviewContent.length > 0) {
      this.$confirm('是否拒绝提现？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        const postParams = {
          outIds: this.curOutId,
          level: +this.curPage, // 1业务审核提交 2总部审核提交  3财务打款(暂无)
          reviewContent,
        };
        IPSService.guiderAllProfitOutReject({ postParams }).then((res) => {
          if (res) {
            this.$message.success('成功拒绝');
            this.getRemitList();
            this.onRejectedReasonPopHide();
          } else {
            this.$message.error('拒绝失败');
          }
        });
      });
    } else {
      this.$message.error('请输入拒绝理由');
    }
  }

  /**
   * 批量线上打款
   * @param {null}
   * @return null
   */
  public batchPayment() {
    this.isShowConfirm = true;
    const realOutCashList = this.selectedList.map(v => v.realOutCash);
    const realOutCashCount = realOutCashList.reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue));
    this.confirmTitle = `确认对选中的${this.selectedList.length}人进行批量线上打款，打款金额￥${realOutCashCount}，打款后将直接把钱付到对方微信账户中`;
    this.successMessage = '批量打款成功';
    this.errorMessage = '批量打款失败';
    this.payType = PAY_TYPE.BATCH_ON_LINE_PAY;
  }

  /**
   * 单个线上打款
   * @param {RemitList} item
   * @return null
   */
  public onConfirmTransfor(item: RemitList): void {
    this.isShowConfirm = true;
    this.confirmTitle = `确定线上打款给【${item.buyerName}】，金额${item.realOutCash}元`;
    this.successMessage = '打款成功';
    this.errorMessage = '打款失败';
    this.payType = PAY_TYPE.ON_LINE_PAY;
    this.selectedInfo = item;
  }

  /**
   * 线下结算
   * @param {RemitList} item
   * @return null
   */
  composeValue(type, row) {
    return {
      key: type,
      item: row,
    };
  }

  offlineSettlement(key) {
    this.isShowConfirm = true;
    if (key.key === 1) {
      this.isCoupon = key.key;
      if (key.item) {
        this.confirmTitle = `确定将【${key.item.buyerName}】本次申请结算的${key.item.realOutCash}元现金券结算`;
        this.successMessage = `${key.item.buyerName}本次的${key.item.realOutCash}元已现金券结算`;
        this.payType = PAY_TYPE.OFF_LINE_PAY;

        this.selectedInfo = key.item;
      } else {
        this.confirmTitle = `确定将选中的${this.selectedList.length}人的结算金额进行现金券结算`;
        this.successMessage = `选中的${this.selectedList.length}人已现金券结算`;
        this.payType = PAY_TYPE.BATCH_OFF_LINE_PAY;
      }
      this.errorMessage = '现金券结算失败';
    } else if(key.key === 2) {
      this.isCoupon = key.key;
      if (key.item) {
        this.confirmTitle = `确定将【${key.item.buyerName}】本次申请结算的${key.item.realOutCash}元银行卡结算`;
        this.successMessage = `${key.item.buyerName}本次的${key.item.realOutCash}元已银行卡结算`;
        this.payType = PAY_TYPE.OFF_LINE_PAY;
        this.selectedInfo = key.item;
      } else {
        this.confirmTitle = `确定将选中的${this.selectedList.length}人的结算金额进行银行卡结算`;
        this.successMessage = `选中的${this.selectedList.length}人已银行卡结算`;
        this.payType = PAY_TYPE.BATCH_OFF_LINE_PAY;
      }
      this.errorMessage = '银行卡结算失败';
    }else{
      this.isCoupon = key.key;
      if (key.item) {
        this.confirmTitle = `确定将【${key.item.buyerName}】本次申请结算的${key.item.realOutCash}元现金结算`;
        this.successMessage = `${key.item.buyerName}本次的${key.item.realOutCash}元已现金结算`;
        this.payType = PAY_TYPE.OFF_LINE_PAY;
        this.selectedInfo = key.item;
      } else {
        this.confirmTitle = `确定将选中的${this.selectedList.length}人的结算金额进行现金结算`;
        this.successMessage = `选中的${this.selectedList.length}人已现金结算`;
        this.payType = PAY_TYPE.BATCH_OFF_LINE_PAY;
      }
      this.errorMessage = '现金结算失败';
    }
  }

  /**
   * 确认打款
   * @return null
   */
  public onConfirm() {
    this.isDisabledConfirm = true;
    let postParams: any = {};
    this.$refs.form.validate((result) => {
      if (result) {
        switch (this.payType) {
          case PAY_TYPE.ON_LINE_PAY:
            postParams = {
              outId: Number(this.selectedInfo.outId),
              isCoupon: this.isCoupon,
            };
            IPSService.guiderAllProfitOutPay({ postParams })
              .then((res) => {
                if (res) {
                  this.$message.success(this.successMessage);
                  this.getRemitList();
                  this.isShowConfirm = false;
                } else {
                  this.$message.error(this.errorMessage);
                  this.getRemitList();
                }
              })
              .catch((error) => {
                this.isShowConfirm = false;
                this.getRemitList();
              });
            break;
          case PAY_TYPE.BATCH_ON_LINE_PAY:
            postParams = {
              outIdArr: this.selectedList.map(selectItem => Number(selectItem.outId)),
              isCoupon: this.isCoupon,
            };

            IPSService.guiderBatchPayment({ postParams })
              .then((response) => {
                if (response.result) {
                  this.$message.success(this.successMessage);
                  this.getRemitList();
                  this.isShowConfirm = false;
                } else {
                  this.$message.error(this.errorMessage);
                  this.getRemitList();
                }
              })
              .catch((error) => {
                this.isShowConfirm = false;
              });
            break;
          case PAY_TYPE.OFF_LINE_PAY:
            postParams = {
              outIds: [Number(this.selectedInfo.outId)],
              outType: this.isCoupon,
            };

            IPSService.offlineSettlement({ postParams })
              .then((response) => {
                if (response.result) {
                  this.$message.success(this.successMessage);
                  this.getRemitList();
                  this.isShowConfirm = false;
                } else {
                  this.$message.error(this.errorMessage);
                  this.getRemitList();
                }
              })
              .catch((error) => {
                this.isShowConfirm = false;
                this.getRemitList();
              });
            break;
          case PAY_TYPE.BATCH_OFF_LINE_PAY:
            postParams = {
              outIds: this.selectedList.map(selectItem => Number(selectItem.outId)),
              outType: this.isCoupon,
            };

            IPSService.offlineSettlement({ postParams })
              .then((response) => {
                if (response.result) {
                  this.$message.success(this.successMessage);
                  this.getRemitList();
                  this.isShowConfirm = false;
                } else {
                  this.$message.error(this.errorMessage);
                  this.getRemitList();
                }
              })
              .catch((error) => {
                this.isShowConfirm = false;
                this.getRemitList();
              });
            break;
          default:
            break;
        }
      } else {
        this.isDisabledConfirm = false;
      }
    });
  }

  get exportParams() {
    const postParams = {
      exportType: 'guiderAllProfitOut',
      params: {
        keywords: this.keywords, // 查询关键字（货号等）
        level: this.curPage !== '5' ? (this.curPage === '6' ? 4 : Number.parseInt(this.curPage) - 1) : 10, // 0待业务审核 1待总部审核 2待打款(待财务审核) 3已打款 4已拒绝 10打款失败
        accountType: this.accountType || 9,
        reviewerType: this.reviewerType,
        order: this.order,
        orderBy: this.orderBy,
        tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
        tag: this.queryParamTag || '9',
        timeType: this.timeType,
        policyType: this.distributionType === '' ? 9 : this.distributionType,
      },
    };
    if (this.date && this.date.length) {
      postParams.params['startTime'] = moment(this.date[0]).format('YYYY-MM-DD');
      postParams.params['endTime'] = moment(this.date[1]).format('YYYY-MM-DD');
    }
    return postParams;
  }

  public openImport() {
    const postParams = {
      keyword: this.keywords,
      sendToId: this.sendToIdList[2], // SOCKET推送ID
      timeType: this.timeType,
      tagName: `${this.tagType}` ? this.tagTypeList[this.tagType] || '' : '',
      policyType: this.distributionType === '' ? 9 : this.distributionType,
      reviewerType: this.reviewerType,
    };
    if (this.date && this.date.length) {
      postParams['startTime'] = moment(this.date[0]).format('YYYY-MM-DD');
      postParams['endTime'] = moment(this.date[1]).format('YYYY-MM-DD');
    }
    importBatchSet
      .open({
        title: '批量设置扣税金额',
        postParams,
        fromKey: 'remit',
        importUrl: 'nips/admin/v/guider/template/list/import',
        data: this.remitList,
        empCode: this.$store.state.empCode,
      })
      .then((result) => {
        this.getRemitList();
      }, noop);
  }

  /**
   * 去往提现历史页面
   * @param {RemitList} item
   * @return null
   */
  public onGoToWithdrawHistory(item: RemitList): void {
    this.$router.push(`/virtualManager/manager/${item.vGuiderId}/1`);
    this.$store.commit('onModifyGuiderName', item.buyerName);
    localStorage.setItem('remit', '1'); // 直接跳转到提现历史页面
  }

  /**
   * 判断菜单权限
   * @param {string} name
   * @return {boolean}
   */
  public menuAuth(name: string): boolean {
    return this.$store.state.authMenuCodeList.includes(name);
  }

  /**
   * 获取当前页索引
   * @return null
   */
  public getNearCurPage(): void {
    // 找到最近的
    if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p1)) {
      this.curPage = '1';
      localStorage.setItem('curPageName', this.pageNameObj.p1);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p2)) {
      this.curPage = '2';
      localStorage.setItem('curPageName', this.pageNameObj.p2);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p3)) {
      this.curPage = '3';
      localStorage.setItem('curPageName', this.pageNameObj.p3);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p4)) {
      this.curPage = '4';
      localStorage.setItem('curPageName', this.pageNameObj.p4);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p5)) {
      this.curPage = '5';
      localStorage.setItem('curPageName', this.pageNameObj.p5);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p6)) {
      this.curPage = '6';
      localStorage.setItem('curPageName', this.pageNameObj.p6);
    }
    this.setCurPageName(this.curPage);
  }

  /**
   * 菜单名称和索引转换
   * @param {string} val
   * @return null
   */
  public getCurPage(val: string): void {
    switch (val) {
      case this.pageNameObj.p1:
        this.curPage = '1';
        break;
      case this.pageNameObj.p2:
        this.curPage = '2';
        break;
      case this.pageNameObj.p3:
        this.curPage = '3';
        break;
      case this.pageNameObj.p4:
        this.curPage = '4';
        break;
      case this.pageNameObj.p5:
        this.curPage = '5';
        break;
      case this.pageNameObj.p6:
        this.curPage = '6';
        break;
    }
  }

  /**
   * 设置当前页名称
   * @return null
   */
  public setCurPageName(key: string): void {
    // 设置缓存
    switch (key) {
      case '1':
        localStorage.setItem('curPageName', this.pageNameObj.p1);
        break;
      case '2':
        localStorage.setItem('curPageName', this.pageNameObj.p2);
        break;
      case '3':
        localStorage.setItem('curPageName', this.pageNameObj.p3);
        break;
      case '4':
        localStorage.setItem('curPageName', this.pageNameObj.p4);
        break;
      case '5':
        localStorage.setItem('curPageName', this.pageNameObj.p6);
        break;
      case '6':
        localStorage.setItem('curPageName', this.pageNameObj.p5);
        break;
    }
  }

  /**
   * 设置菜单权限
   * @return null
   */
  public menuAuthSet(): void {
    if (localStorage.getItem('curPageName')) {
      this.getCurPage(localStorage.getItem('curPageName'));
    } else {
      this.getNearCurPage();
    }
  }

  /**
   * 点击树节点时
   * @param {ItemObject} node
   */
  // public onClickNode(node) {
  //   this.page = 1;
  //   this.pageSize = 10;
  //   this.siteCodes = this.getTreeAllSite(node);
  //   this.isSelected = false;
  //   this.selectedList = [];
  //   this.tagType = '';
  //   if (this.siteCodes.length === 0) {
  //     this.remitList = [];
  //   } else {
  //     this.getRemitList();
  //     this.getTagList();
  //   }
  // }

  /**
   * 获取该节点下所有code
   * @returns {string[]}
   */
  // getTreeAllSite(data) {
  //   const childSite = [];
  //   const deepSearch = (node) => {
  //     if (node.isSite) {
  //       childSite.push(node.code);
  //       return;
  //     } else if (Array.isArray(node.children) && node.children.length) {
  //       node.children.forEach((i) => {
  //         deepSearch(i);
  //       });
  //     }
  //   };
  //   deepSearch(data);
  //   return childSite;
  // }

  /**
   * 分销类型切换
   * @return null
   */
  public distributionTypeChange(val) {
    this.getRemitList();
  }

  /**
   * 获取角色标签列表
   * @return null
   */
  public getTagList() {
    IPSService.guiderTagList({
      postParams: {
        siteCode: this.siteCodes,
      },
    }).then((response) => {
      this.tagTypeList = response.list;
    });
  }

  /**
   * 切换标签角色
   * @return null
   */
  public onTagTypeChange(val) {
    this.getRemitList();
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-DISTRIBUTE-CASH');
    if (this.isContentBodyShow) {
      const list = ['embryform', 'devtest2', 'really'];
      this.isShowBank = showPlatform(list)
      this.menuAuthSet();
      this.defaultStart = new Date(new Date(new Date().toLocaleDateString()).getTime() - 30 * 24 * 60 * 60 * 1000);
      this.defaultEnd = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
      this.date = [this.defaultStart, this.defaultEnd];
      this.getRemitList();
      this.getTagList();
      // // 因为有三个下载，所以每次切换时，需重新连接socket
      // this.closeSockets();
      // this.createConnect();
    }
  }

  // /**
  //  * 当组建即将销毁时
  //  * @return null
  //  */
  // public beforeDestroy() {
  //   this.closeSockets();
  // }

  /**
   * 切换结算类型
   */

  public accountTypeChange() {
    this.getRemitList();
  }

  /**
   * 选择标签筛选条件
   * @param {string} value
   * @return null
   */
  public selectQueryParamTag(value: string) {
    this.queryParamTag = value;
    this.getRemitList();
  }
}
